import analyticsService from "@/services/analytics/analytics-service"
import { useUserStore } from "@/store/user-store"
import { getActivePinia } from "pinia"

async function handleLogInEvent() {
  const userStore = useUserStore()
  analyticsService.loggedIn(userStore.user!)
}

async function handleLogOutEvent() {
  analyticsService.loggedOut()
  _clearAllStores()
}

function handleUnauthenticatedApiResponse() {
  const userStore = useUserStore()
  if (userStore.isLoggedIn) {
    userStore.logout()
  }
}

function handleAccessTokenRefreshed(data: { newAccessToken: string; newRefreshToken: string }) {
  const userStore = useUserStore()
  if (userStore.isLoggedIn) {
    userStore.setAuthTokens(data.newAccessToken, data.newRefreshToken)
  }
}

function _clearAllStores() {
  // @ts-ignore -- clear all stores
  getActivePinia()._s.forEach((store) => store.$reset())
}

export default {
  handleLogInEvent,
  handleLogOutEvent,
  handleUnauthenticatedApiResponse,
  handleAccessTokenRefreshed
}
